import ActionsCell from "./ActionsCell";

export const getColumns = () => [
  {
    field: "full_name",
    headerName: "Full Name",
    width: 220,
  },
  {
    field: "total_jobs",
    headerName: "Total Jobs",
    width: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_finished_jobs",
    headerName: "Total Finished Jobs",
    width: 220,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_pending_jobs",
    headerName: "Total Pending Jobs",
    width: 220,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_spend_time",
    headerName: "Total Time Spent",
    width: 200,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "action",
    headerName: "Actions",
    width: 250,
    sortable: false,
    renderCell: (params) => <ActionsCell params={params} />,
  },
];
